<template>
  <div id="printItem" v-show="isPrintingItem">
    <ReportHeader>{{ staffName }} Workers Comp</ReportHeader>
    <v-row>
      <table>
        <tr>
          <th>Injury Date</th>
          <td>{{ items.injuryDate }}</td>
        </tr>
        <tr>
          <th>Claim Number</th>
          <td>{{ items.claimNumber }}</td>
        </tr>
        <tr>
          <th>Claim Accepted by Carrier?</th>
          <td>{{ items.accepted }}</td>
        </tr>
        <tr>
          <th>Notes</th>
          <td>
            <div class="outlined">{{ items.notes }}</div>
          </td>
        </tr>
        <tr>
          <th>Workers Comp Documents</th>
          <td>
            <v-col
              cols="12"
              sm="12"
              md="12"
              v-for="(doc, index) in items.physicianDocument"
              :key="index"
            >
              <div v-if="doc.ext != 'pdf'">
                <v-img max-height="480" max-width="550" :src="doc.aws"></v-img>
              </div>
              <div v-if="doc.ext == 'pdf'">
                <a :href="doc.aws">Document {{ index + 1 }}</a>
              </div>
            </v-col>
          </td>
        </tr>
        <tr>
          <th>Physician Name</th>
          <td>{{ items.physician }}</td>
        </tr>
        <tr>
          <th>Date of Physician Visit</th>
          <td>{{ items.physicianDate }}</td>
        </tr>
        <tr>
          <th>Date Tested</th>
          <td>{{ items.testedDate }}</td>
        </tr>
        <tr>
          <th>Results of Test</th>
          <td>{{ items.results }}</td>
        </tr>
        <tr>
          <th>Was the Test Positive?</th>
          <td>{{ items.positive }}</td>
        </tr>
      </table>
    </v-row>
  </div>
</template>

<script>
import ReportHeader from "@/components/Report/ReportHeader.vue";

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
    staffName: {
      type: String,
      default: "",
    },
    isPrintingItem: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReportHeader,
  },
};
</script>
